module.exports = __webpack_public_path__ + "img/tracking-logo.2be1ff07.png";